import { IconButton, Tooltip } from "@mui/material"
import { CustomeIconButtonProps } from "./types"

export const CustomeIconButton = ({ title, iconButtonProps, icon }:CustomeIconButtonProps) => {
    return (
        <Tooltip title={title}>
            <IconButton children={icon} {...iconButtonProps}/>
        </Tooltip>
    )
}